import {map} from 'lodash';
import {errorHandler} from 'utils/errorHandler';

const LOAD_TICKETS = 'server-sts/tickets/LOAD_TICKETS';
const LOAD_TICKETS_SUCCESS = 'server-sts/tickets/LOAD_TICKETS_SUCCESS';
const LOAD_TICKETS_FAIL = 'server-sts/tickets/LOAD_TICKETS_FAIL';

const SAVE_TICKET = 'server-sts/tickets/SAVE_TICKETS';
const SAVE_TICKET_SUCCESS = 'server-sts/tickets/SAVE_TICKET_SUCCESS';
const SAVE_TICKET_FAIL = 'server-sts/tickets/SAVE_TICKET_FAIL';


const EDIT_MESSAGE_START = 'server-sts/tickets/EDIT_MESSAGE_START';
const EDIT_MESSAGE_STOP = 'server-sts/tickets/EDIT_MESSAGE_STOP';

const EDIT_TICKET_START = 'server-sts/tickets/EDIT_TICKET_START';
const EDIT_TICKET_STOP = 'server-sts/tickets/EDIT_TICKET_STOP';


const SAVE_MESSAGE = 'server-sts/tickets/SAVE_MESSAGE';
const SAVE_MESSAGE_SUCCESS = 'server-sts/tickets/SAVE_MESSAGE_SUCCESS';
const SAVE_MESSAGE_FAIL = 'server-sts/tickets/SAVE_FAIL';

const DELETE_MESSAGE = 'server-sts/tickets/DELETE_MESSAGE';
const DELETE_MESSAGE_SUCCESS = 'server-sts/tickets/DELETE_MESSAGE_SUCCESS';
const DELETE_MESSAGE_FAIL = 'server-sts/tickets/DELETE_MESSAGE_FAIL';

const CREATE_MESSAGE = 'server-sts/tickets/CREATE_MESSAGE';
const CREATE_MESSAGE_SUCCESS = 'server-sts/tickets/CREATE_MESSAGE_SUCCESS';
const CREATE_MESSAGE_FAIL = 'server-sts/tickets/CREATE_MESSAGE_FAIL';

const CLEAR_TICKETS = 'server-sts/tickets/CLEAR_TICKETS';


const initialState = {
  loaded: false,
  loading: false,
  message_created: false,
  ticket_editing: {},
  message_editing: {},
  saveMessageError: {},
  saveMessageSuccess:false,
  saveTicketError: {},
  saveTicketSuccess:false,
  error:false,
  data:[]
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {
    case LOAD_TICKETS:
      return {
        ...state,
        loading: true
      };
    case LOAD_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: false
      };
    case LOAD_TICKETS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: errorHandler(action.error)
      };

    case DELETE_MESSAGE:
      return {
        ...state,
        loading: true
      };
    case DELETE_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.result.tickets,
        error: null
      };
    case DELETE_MESSAGE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    
      
      
    case EDIT_MESSAGE_START:
      return {
        ...state,
        ticket_message_editing: {
          ...state.ticket_message_editing,
          [action.id]: true
        }
      };
    case EDIT_MESSAGE_STOP:
      return {
        ...state,
        ticket_message_editing: {
          ...state.ticket_message_editing,
          [action.id]: false
        },
        saveMessageSuccess: false,
        saveMessageError : {
        	...state.saveError,
        	[action.id]: null,
        }
      };


    case EDIT_TICKET_START:
      return {
        ...state,
        ticket_editing: {
          ...state.editing,
          [action.id]: true
        }
      };
    case EDIT_TICKET_STOP:
      return {
        ...state,
        ticket_editing: {
          ...state.ticket_editing,
          [action.id]: false
        },
        saveTicketSuccess: false,
        saveTicketError : {
        	...state.saveTicketError,
        	[action.id]: null,
        }
      };
      
      
    case SAVE_TICKET:
      return state; // 'saving' flag handled by redux-form
    case SAVE_TICKET_SUCCESS:
      var tickets = action.result;
      return {
        data: tickets,
        ticket_editing: {
          ...state.ticket_editing,
          [action.result.id]: false
        },
        saveTicketError: {
          ...state.saveTicketError,
          [action.result.id]: null
        },
        saveTicketSuccess: true,
      };
    case SAVE_TICKET_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveTicketError: {
          ...state.saveTicketError,
          [action.id]: action.error
        },
        saveTicketSuccess: false,
      } : state;


    case SAVE_MESSAGE:
      return state; // 'saving' flag handled by redux-form
    case SAVE_MESSAGE_SUCCESS:
      var tickets = action.result;
      return {
        data: tickets,
        editing: {
          ...state.editing,
          [action.result.id]: false
        },
        saveError: {
          ...state.saveError,
          [action.result.id]: null
        },
        saveSuccess: true,
        saveErrors: false
      };
    case SAVE_MESSAGE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        saveError: {
          ...state.saveError,
          [action.id]: action.error
        },
        saveSuccess: false,
      } : state;
    default:
      return state;
    
    
    case CLEAR_TICKETS:
    	return {
    		...state, 
    		data:[],
    		loaded:false
    	}
    
    
    case CREATE_MESSAGE:
      return state;
      
    case CREATE_MESSAGE_SUCCESS:
      var messages = action.result.messages;
      return {
        data: messages,
        createSuccess: true,
        createErrors: false
      };
      
    case CREATE_MESSAGE_FAIL:
      return typeof action.error === 'string' ? {
        ...state,
        createError:true,
        createSuccess: false,
      } : state;
   
  }
}

export function isLoaded(globalState) {
  return globalState.tickets && globalState.tickets.loaded;
}



export function load(params) {
	
  return {
    promise: (module) => module.post('/ticket/load', {data:{params}}),
    types: [LOAD_TICKETS, LOAD_TICKETS_SUCCESS, LOAD_TICKETS_FAIL]
  };
}


export function createMessage(message, t_id, params) {
	
  return {
    types: [SAVE_MESSAGE, SAVE_MESSAGE_SUCCESS, SAVE_MESSAGE_FAIL],
    promise: (module) => module.post('/ticket/createMessage', {
      data: {message, t_id, params}
    })
  };
}


export function saveMessage(values) {
  return {
    types: [SAVE_MESSAGE, SAVE_MESSAGE_SUCCESS, SAVE_MESSAGE_FAIL],
    id: values.id,
    promise: (module) => module.post('/ticket/saveMessage', {
      data: {...values}
    })
  };
}

export function deleteMessage(id) {
  return {
    types: [DELETE_MESSAGE, DELETE_MESSAGE_SUCCESS, DELETE_MESSAGE_FAIL],
    promise: (module) => module.post('/ticket/deleteMessage', {
      data: {id}
    })
  };
}

export function editStart(id) {
  return { type: EDIT_START, id };
}

export function editStop(id) {
  return { type: EDIT_STOP, id };
}

export function clearTickets() {
  return { type: CLEAR_TICKETS };
}
